import { Combo, StringHelper } from "@bryntum/schedulerpro";
import TaskEditorColorMapping from "../../../other/constants/TaskEditorColors.jsx";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";

function findParent(elConfig) {
  if (elConfig?.children && Array.isArray(elConfig?.children) && elConfig?.children.findIndex(child => child?.tag === "input") !== -1) {
    return elConfig;
  } else {
    let result;

    if (Array.isArray(elConfig?.children)) {
      elConfig?.children?.forEach(el => {
        if (!result) {
          result = findParent(el);
        }
      });
    }

    return result;
  }
}

export default class SwivuColorField extends Combo {
  static get $name() {
    return "SwivuColorField";
  }

  static get type() {
    return WIDGET_KEYS.colorField;
  }

  static get fields() {
    return [
      { name: "isEventColor", persist: false },
      { name: "canDisplayColorIcon", type: "boolean", defaultValue: false, persist: false },
      { name: "canRemoveColor", type: "boolean", defaultValue: false, persist: false }
    ];
  }

  static get configurable() {
    return {
      editable: false,
      picker: {
        cls: {
          colorpicker: 1,
          "hidden-scrollbar": 2,
        },
      },
      listItemTpl: (item) => {
        if(Array.isArray(item.value)) {
          return StringHelper.xss`<div class="color-box" data-color="${item.value}" style="background: linear-gradient(${item.value.join(', ')})"></div>`;
        }
        if (item?.value?.split("")?.[item?.value?.length - 1] === "x") {
          return StringHelper.xss`<div class="color-box" data-color="${item.value}" style="background-color: transparent; box-shadow: none; user-select: none; pointer-events: none;"></div>`;
        } else if (!item.value) {
          return StringHelper.xss`<div class="color-box" data-color="${item.value}" >
            <i class="fa-regular fa-eraser"></i>
            Remove color
          </div>`
        }
        else {
          return StringHelper.xss`<div class="color-box" data-color="${item.value}" style="background-color: ${item.value}"></div>`;
        }
      },
      items: TaskEditorColorMapping.map((item) => [
        item?.color,
      ]),
    }
  }

  compose() {
    const result = super.compose();

    // compose was being called multiple times therefore mixed value record gets inserted into store multiple times.
    // To prevent this behavior a check was applied if the record has already been inserted into store
    if (this.store) {
      if (this.canRemoveColor && !this.store.findRecord("value", "", true)) {
        this.store.add({
          text: "",
          value: ""
        })
        this.picker.element.classList.add("can-remove-color");
      }
      if (this.isEventColor && !this.store.findByField("text", "mixed").length) {
        this.store.insert(0, {
          value: ['red', 'pink', 'purple', 'indigo', 'blue', 'cyan', 'teal', 'green', 'yellow', 'orange'],
          text: 'mixed',
        })
      }
    }

    // Find a parent element which contains input element
    const parent = findParent(result);

    // If element is found, add special html element to show the color
    if (parent) {
      if (this.canDisplayColorIcon) {
        parent.children.push({
          class: "color-bar fa-light fa-palette flex items-center !left-5",
          style: `${this.value ? `color: ${this.value}` : ""}`
        })
      } else {
        parent.children.push({
          class: "color-bar",
          style: `background-color: ${this.value || "transparent"}; width: calc(100% - 60px)`
        });
      }
    }


    return result;
  }

  onChange({ value, source }) {
    super.onChange?.();
    if (this.isEventColor) source.input.style.color = 'transparent'
    // When value is changed, look up for the color bar element and set background color on it
    const colorBarEl = this.element.querySelector(".color-bar");

    if (colorBarEl) {
      if (this.canDisplayColorIcon) {
        colorBarEl.style.color = value;
      } else {
        colorBarEl.style.backgroundColor = value || 'transparent';
      }
    }

    if (this.isEventColor && Array.isArray(value)) {
      colorBarEl.style.backgroundColor = 'transparent';
      source.input.style.color = 'inherit';
      source.input.style.textTransform = 'capitalize';
    }
  }
}

SwivuColorField.initClass();
